/**
 * Loop 2000E — Patient Event Level (005010X217 Table 2).
 * Includes all situational segments; sample values from TR3 §3.2 inpatient surgery.
 */
export const PATIENT_EVENT_SEGMENTS = [
  {
    segmentId: "HL_2000E",
    tag: "HL",
    pos: "0100",
    raw: "HL*4*3*EV*1~",
    isOptional: false,
    elements: [
      { position: 1, elementId: "HL01", label: "Hierarchical ID Number", value: "4", required: true, dataType: "AN" },
      { position: 2, elementId: "HL02", label: "Hierarchical Parent ID Number", value: "3", required: true, dataType: "AN" },
      { position: 3, elementId: "HL03", label: "Hierarchical Level Code", value: "EV", required: true, dataType: "ID" },
      { position: 4, elementId: "HL04", label: "Hierarchical Child Code", value: "1", required: true, dataType: "ID" },
    ],
  },
  {
    segmentId: "TRN_EVENT",
    tag: "TRN",
    pos: "0200",
    raw: "TRN*1*987654321*9876543210~",
    isOptional: true,
    elements: [
      { position: 1, elementId: "TRN01", label: "Trace Type Code", value: "1", required: true, dataType: "ID" },
      { position: 2, elementId: "TRN02", label: "Patient Event Tracking Number", value: "987654321", required: true, dataType: "AN" },
      { position: 3, elementId: "TRN03", label: "Originating Company Identifier", value: "9876543210", required: false, dataType: "AN" },
    ],
  },
  {
    segmentId: "UM_EVENT",
    tag: "UM",
    pos: "0400",
    raw: "UM*AR*I*2*21:B:1*21**Y~",
    isOptional: false,
    elements: [
      { position: 1, elementId: "UM01", label: "Request Category Code", value: "AR", required: true, dataType: "ID" },
      { position: 2, elementId: "UM02", label: "Certification Type Code", value: "I", required: true, dataType: "ID" },
      { position: 3, elementId: "UM03", label: "Service Type Code", value: "2", required: false, dataType: "ID" },
      { position: 4, elementId: "UM04", label: "Health Care Service Procedure Code", value: "21:B:1", required: false, dataType: "AN" },
      { position: 5, elementId: "UM05", label: "Place of Service Code", value: "21", required: false, dataType: "AN" },
      { position: 7, elementId: "UM07", label: "Yes/No Condition Response Code", value: "Y", required: false, dataType: "ID" },
    ],
  },
  {
    segmentId: "REF_BB",
    tag: "REF",
    pos: "0600",
    raw: "REF*BB*AUTH0002~",
    isOptional: true,
    elements: [
      { position: 1, elementId: "REF01", label: "Reference Identification Qualifier", value: "BB", required: true, dataType: "ID" },
      { position: 2, elementId: "REF02", label: "Previous Review Authorization Number", value: "AUTH0002", required: true, dataType: "AN" },
    ],
  },
  {
    segmentId: "REF_ADMIN",
    tag: "REF",
    pos: "0600",
    raw: "REF*9F*ADMIN-REF-001~",
    isOptional: true,
    elements: [
      { position: 1, elementId: "REF01", label: "Reference Identification Qualifier", value: "9F", required: true, dataType: "ID" },
      { position: 2, elementId: "REF02", label: "Previous Review Administrative Reference Number", value: "ADMIN-REF-001", required: true, dataType: "AN" },
    ],
  },
  {
    segmentId: "DTP_ACCIDENT",
    tag: "DTP",
    pos: "0700",
    raw: "",
    isOptional: true,
    elements: [
      { position: 1, elementId: "DTP01", label: "Date Time Qualifier", value: "439", required: true, dataType: "ID" },
      { position: 2, elementId: "DTP02", label: "Date Time Period Format Qualifier", value: "D8", required: true, dataType: "ID" },
      { position: 3, elementId: "DTP03", label: "Accident Date", value: "", required: true, dataType: "DT" },
    ],
  },
  {
    segmentId: "DTP_LMP",
    tag: "DTP",
    pos: "0700",
    raw: "",
    isOptional: true,
    elements: [
      { position: 1, elementId: "DTP01", label: "Date Time Qualifier", value: "484", required: true, dataType: "ID" },
      { position: 2, elementId: "DTP02", label: "Date Time Period Format Qualifier", value: "D8", required: true, dataType: "ID" },
      { position: 3, elementId: "DTP03", label: "Last Menstrual Period Date", value: "", required: true, dataType: "DT" },
    ],
  },
  {
    segmentId: "DTP_EDB",
    tag: "DTP",
    pos: "0700",
    raw: "",
    isOptional: true,
    elements: [
      { position: 1, elementId: "DTP01", label: "Date Time Qualifier", value: "455", required: true, dataType: "ID" },
      { position: 2, elementId: "DTP02", label: "Date Time Period Format Qualifier", value: "D8", required: true, dataType: "ID" },
      { position: 3, elementId: "DTP03", label: "Estimated Date of Birth", value: "", required: true, dataType: "DT" },
    ],
  },
  {
    segmentId: "DTP_ONSET",
    tag: "DTP",
    pos: "0700",
    raw: "",
    isOptional: true,
    elements: [
      { position: 1, elementId: "DTP01", label: "Date Time Qualifier", value: "431", required: true, dataType: "ID" },
      { position: 2, elementId: "DTP02", label: "Date Time Period Format Qualifier", value: "D8", required: true, dataType: "ID" },
      { position: 3, elementId: "DTP03", label: "Onset of Current Symptoms or Illness Date", value: "", required: true, dataType: "DT" },
    ],
  },
  {
    segmentId: "DTP_EVENT",
    tag: "DTP",
    pos: "0700",
    raw: "DTP*435*RD8*20250720-20250727~",
    isOptional: true,
    elements: [
      { position: 1, elementId: "DTP01", label: "Date Time Qualifier", value: "435", required: true, dataType: "ID" },
      { position: 2, elementId: "DTP02", label: "Date Time Period Format Qualifier", value: "RD8", required: true, dataType: "ID" },
      { position: 3, elementId: "DTP03", label: "Event / Admission Date Period", value: "20250720-20250727", required: true, dataType: "DT" },
    ],
  },
  {
    segmentId: "DTP_ADMISSION",
    tag: "DTP",
    pos: "0700",
    raw: "DTP*435*D8*20250720~",
    isOptional: true,
    elements: [
      { position: 1, elementId: "DTP01", label: "Date Time Qualifier", value: "435", required: true, dataType: "ID" },
      { position: 2, elementId: "DTP02", label: "Date Time Period Format Qualifier", value: "D8", required: true, dataType: "ID" },
      { position: 3, elementId: "DTP03", label: "Admission Date", value: "20250720", required: true, dataType: "DT" },
    ],
  },
  {
    segmentId: "DTP_DISCHARGE",
    tag: "DTP",
    pos: "0700",
    raw: "",
    isOptional: true,
    elements: [
      { position: 1, elementId: "DTP01", label: "Date Time Qualifier", value: "096", required: true, dataType: "ID" },
      { position: 2, elementId: "DTP02", label: "Date Time Period Format Qualifier", value: "D8", required: true, dataType: "ID" },
      { position: 3, elementId: "DTP03", label: "Discharge Date", value: "", required: true, dataType: "DT" },
    ],
  },
  {
    segmentId: "DTP_472",
    tag: "DTP",
    pos: "0700",
    raw: "DTP*472*D8*20250722~",
    isOptional: true,
    elements: [
      { position: 1, elementId: "DTP01", label: "Date Time Qualifier", value: "472", required: true, dataType: "ID" },
      { position: 2, elementId: "DTP02", label: "Date Time Period Format Qualifier", value: "D8", required: true, dataType: "ID" },
      { position: 3, elementId: "DTP03", label: "Service Date", value: "20250722", required: true, dataType: "DT" },
    ],
  },
  {
    segmentId: "HI_EVENT",
    tag: "HI",
    pos: "0800",
    raw: "HI*ABK:I219~",
    isOptional: true,
    elements: [
      { position: 1, elementId: "HI01", label: "Primary Diagnosis (ICD-10)", value: "ABK:I219", required: true, dataType: "AN" },
      { position: 2, elementId: "HI02", label: "Diagnosis 2", value: "", required: false, dataType: "AN" },
      { position: 3, elementId: "HI03", label: "Diagnosis 3", value: "", required: false, dataType: "AN" },
    ],
  },
  {
    segmentId: "HSD_LOS",
    tag: "HSD",
    pos: "0900",
    raw: "HSD*DY*7~",
    isOptional: true,
    elements: [
      { position: 1, elementId: "HSD01", label: "Quantity Qualifier", value: "DY", required: true, dataType: "ID" },
      { position: 2, elementId: "HSD02", label: "Length of Stay (Days)", value: "7", required: true, dataType: "R" },
    ],
  },
  {
    segmentId: "HSD_FREQ",
    tag: "HSD",
    pos: "0900",
    raw: "",
    isOptional: true,
    elements: [
      { position: 1, elementId: "HSD01", label: "Quantity Qualifier", value: "VS", required: true, dataType: "ID" },
      { position: 2, elementId: "HSD02", label: "Frequency Quantity", value: "", required: true, dataType: "R" },
      { position: 3, elementId: "HSD03", label: "Frequency Period Unit", value: "", required: false, dataType: "ID" },
    ],
  },
  {
    segmentId: "CRC_AMBULANCE",
    tag: "CRC",
    pos: "1000",
    raw: "",
    isOptional: true,
    elements: [
      { position: 1, elementId: "CRC01", label: "Code Category", value: "07", required: true, dataType: "ID" },
      { position: 2, elementId: "CRC02", label: "Certification Condition Indicator", value: "", required: true, dataType: "ID" },
      { position: 3, elementId: "CRC03", label: "Condition Code 1", value: "", required: false, dataType: "ID" },
    ],
  },
  {
    segmentId: "CRC_CHIRO",
    tag: "CRC",
    pos: "1000",
    raw: "",
    isOptional: true,
    elements: [
      { position: 1, elementId: "CRC01", label: "Code Category", value: "08", required: true, dataType: "ID" },
      { position: 2, elementId: "CRC02", label: "Certification Condition Indicator", value: "", required: true, dataType: "ID" },
      { position: 3, elementId: "CRC03", label: "Condition Code 1", value: "", required: false, dataType: "ID" },
    ],
  },
  {
    segmentId: "CRC_DME",
    tag: "CRC",
    pos: "1000",
    raw: "CRC*09*Y*29~",
    isOptional: true,
    elements: [
      { position: 1, elementId: "CRC01", label: "Code Category", value: "09", required: true, dataType: "ID" },
      { position: 2, elementId: "CRC02", label: "Certification Condition Indicator", value: "Y", required: true, dataType: "ID" },
      { position: 3, elementId: "CRC03", label: "DME Condition Code", value: "29", required: false, dataType: "ID" },
    ],
  },
  {
    segmentId: "CRC_OXYGEN",
    tag: "CRC",
    pos: "1000",
    raw: "",
    isOptional: true,
    elements: [
      { position: 1, elementId: "CRC01", label: "Code Category", value: "E1", required: true, dataType: "ID" },
      { position: 2, elementId: "CRC02", label: "Certification Condition Indicator", value: "", required: true, dataType: "ID" },
      { position: 3, elementId: "CRC03", label: "Condition Code 1", value: "", required: false, dataType: "ID" },
    ],
  },
  {
    segmentId: "CL1_EVENT",
    tag: "CL1",
    pos: "1100",
    raw: "CL1*2~",
    isOptional: true,
    elements: [
      { position: 1, elementId: "CL101", label: "Admission Type Code", value: "2", required: true, dataType: "ID" },
    ],
  },
  {
    segmentId: "CR1_EVENT",
    tag: "CR1",
    pos: "1200",
    raw: "",
    isOptional: true,
    elements: [
      { position: 1, elementId: "CR101", label: "Unit or Basis for Measurement Code", value: "", required: false, dataType: "ID" },
      { position: 2, elementId: "CR102", label: "Patient Weight", value: "", required: false, dataType: "R" },
      { position: 5, elementId: "CR105", label: "Ambulance Transport Reason Code", value: "", required: false, dataType: "ID" },
      { position: 9, elementId: "CR109", label: "Transport Distance", value: "", required: false, dataType: "R" },
    ],
  },
  {
    segmentId: "CR2_EVENT",
    tag: "CR2",
    pos: "1300",
    raw: "",
    isOptional: true,
    elements: [
      { position: 1, elementId: "CR201", label: "Count", value: "", required: false, dataType: "N0" },
      { position: 2, elementId: "CR202", label: "Quantity", value: "", required: false, dataType: "R" },
      { position: 3, elementId: "CR203", label: "Subluxation Level Code", value: "", required: false, dataType: "ID" },
    ],
  },
  {
    segmentId: "CR5_EVENT",
    tag: "CR5",
    pos: "1400",
    raw: "",
    isOptional: true,
    elements: [
      { position: 1, elementId: "CR501", label: "Certification Type Code", value: "", required: false, dataType: "ID" },
      { position: 2, elementId: "CR502", label: "Quantity", value: "", required: false, dataType: "R" },
      { position: 3, elementId: "CR503", label: "Oxygen Equipment Type Code", value: "", required: false, dataType: "ID" },
    ],
  },
  {
    segmentId: "CR6_EVENT",
    tag: "CR6",
    pos: "1500",
    raw: "",
    isOptional: true,
    elements: [
      { position: 1, elementId: "CR601", label: "Certification Type Code", value: "", required: false, dataType: "ID" },
      { position: 2, elementId: "CR602", label: "Quantity", value: "", required: false, dataType: "R" },
      { position: 3, elementId: "CR603", label: "Duration Unit Code", value: "", required: false, dataType: "ID" },
    ],
  },
  {
    segmentId: "PWK_EVENT",
    tag: "PWK",
    pos: "1550",
    raw: "PWK*OZ*EL***AC*CLINICALDOC~",
    isOptional: true,
    elements: [
      { position: 1, elementId: "PWK01", label: "Attachment Report Type Code", value: "OZ", required: true, dataType: "ID" },
      { position: 2, elementId: "PWK02", label: "Report Transmission Code", value: "EL", required: false, dataType: "ID" },
      { position: 5, elementId: "PWK05", label: "Identification Code Qualifier", value: "AC", required: false, dataType: "ID" },
      { position: 6, elementId: "PWK06", label: "Attachment Control Number", value: "CLINICALDOC", required: false, dataType: "AN" },
    ],
  },
  {
    segmentId: "MSG_EVENT",
    tag: "MSG",
    pos: "1600",
    raw: "MSG*PRIOR AUTHORIZATION REQUEST FOR INPATIENT SURGERY~",
    isOptional: true,
    elements: [
      { position: 1, elementId: "MSG01", label: "Message Text", value: "PRIOR AUTHORIZATION REQUEST FOR INPATIENT SURGERY", required: true, dataType: "AN" },
    ],
  },
  {
    segmentId: "NM1_FA",
    tag: "NM1",
    pos: "1700",
    raw: "NM1*FA*2*Montgomery Hospital*****XX*1234567890~",
    isOptional: true,
    elements: [
      { position: 1, elementId: "NM101", label: "Entity Identifier Code", value: "FA", required: true, dataType: "ID" },
      { position: 2, elementId: "NM102", label: "Entity Type Qualifier", value: "2", required: true, dataType: "ID" },
      { position: 3, elementId: "NM103", label: "Facility Name", value: "Montgomery Hospital", required: true, dataType: "AN" },
      { position: 8, elementId: "NM108", label: "Identification Code Qualifier", value: "XX", required: false, dataType: "ID" },
      { position: 9, elementId: "NM109", label: "Facility Identifier", value: "1234567890", required: false, dataType: "AN" },
    ],
  },
  {
    segmentId: "N3_FA",
    tag: "N3",
    pos: "1800",
    raw: "N3*475 Main Street~",
    isOptional: true,
    elements: [
      { position: 1, elementId: "N301", label: "Facility Address Line 1", value: "475 Main Street", required: true, dataType: "AN" },
      { position: 2, elementId: "N302", label: "Facility Address Line 2", value: "", required: false, dataType: "AN" },
    ],
  },
  {
    segmentId: "N4_FA",
    tag: "N4",
    pos: "1900",
    raw: "N4*Anytown*PA*19087~",
    isOptional: true,
    elements: [
      { position: 1, elementId: "N401", label: "City Name", value: "Anytown", required: true, dataType: "AN" },
      { position: 2, elementId: "N402", label: "State or Province Code", value: "PA", required: false, dataType: "ID" },
      { position: 3, elementId: "N403", label: "Postal Code", value: "19087", required: false, dataType: "ID" },
    ],
  },
  {
    segmentId: "NM1_EP",
    tag: "NM1",
    pos: "1700",
    raw: "",
    isOptional: true,
    elements: [
      { position: 1, elementId: "NM101", label: "Entity Identifier Code", value: "", required: true, dataType: "ID" },
      { position: 2, elementId: "NM102", label: "Entity Type Qualifier", value: "", required: true, dataType: "ID" },
      { position: 3, elementId: "NM103", label: "Patient Event Provider Name", value: "", required: true, dataType: "AN" },
    ],
  },
  {
    segmentId: "REF_EP",
    tag: "REF",
    pos: "1800",
    raw: "",
    isOptional: true,
    elements: [
      { position: 1, elementId: "REF01", label: "Reference Identification Qualifier", value: "", required: true, dataType: "ID" },
      { position: 2, elementId: "REF02", label: "Provider Supplemental Information", value: "", required: true, dataType: "AN" },
    ],
  },
];

/** Build line-wise raw EDI for segments that have a raw value. */
export function buildPatientEventRawEdi(segments) {
  return segments
    .filter((s) => s.raw)
    .map((s) => s.raw)
    .join("");
}
